// Telia colour palette - referenced as P.<name> in copy.js and across the presentation.
export const P = {
  // Telia base
  deep:    "#29003E",
  dark:    "#3D1556",
  card:    "#4A1969",
  purple:  "#990AE3",
  light:   "#F4E0FF",
  magenta: "#C23FE3",
  teal:    "#00827C",
  // Futuristic accents
  cyan:    "#00D4FF",
  electric:"#7DD3FC",
  gold:    "#FFD740",
  green:   "#69F0AE",
  red:     "#FF5252",
  orange:  "#FF8A65",
  // Text tones
  white:   "#FFFFFF",
  dim:     "rgba(244,224,255,0.65)",
  muted:   "rgba(244,224,255,0.4)",
  faint:   "rgba(244,224,255,0.15)",
};
